const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const authHeaders = () => {
  const token = localStorage.getItem(process.env.REACT_APP_CIAM_ACCESS_KEY);
  return {
    Authorization: `Bearer ${token}`,
    "consumer-key": process.env.REACT_APP_FORGEROCK_CONSUMER_KEY,
  };
};

export const getAccessRequestQueue = async () => {
  const res = await fetch(`${BASE_URL}/api/access-request/queue`, {
    headers: authHeaders(),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok || body.success === false) {
    throw new Error(body.message || `Failed to load queue: ${res.status}`);
  }
  return body.requests || [];
};

const decide = async (id, decision) => {
  const res = await fetch(`${BASE_URL}/api/access-request/${id}/${decision}`, {
    method: "POST",
    headers: authHeaders(),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok || body.success === false) {
    throw new Error(body.message || `Failed to ${decision} request: ${res.status}`);
  }
  return body;
};

export const approveAccessRequest = (id) => decide(id, "approve");
export const rejectAccessRequest = (id) => decide(id, "reject");
